// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3HzcA","topBottomGutter":"Layout_topBottomGutter__2DonK"};